import { useCallback, useEffect, useState } from "react";
import { Button, Stack, Typography } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useAuthContext } from "contexts";
import { logger } from "utils";
import useEffectAfterMount from "hooks/useEffectAfterMount";
import { useTranslation } from "react-i18next";

const ResendOtp = ({ type, isLogin, resetField, count = 30, error = null }) => {
  const { t } = useTranslation();
  const [countDown, setCountDown] = useState(count);
  const { userSession, login, refreshOtp } = useAuthContext();

  const resendOtp = useCallback(
    async (event) => {
      event?.preventDefault();
      try {
        if (isLogin) {
          const { email } = userSession;
          await login({ email });
        } else {
          await refreshOtp({ type });
        }
        setCountDown(count);
        if (!!resetField && typeof resetField === "function") {
          resetField();
        }
      } catch (error) {
        logger.error("Error in resending OTP:", error);
      }
    },
    [
      refreshOtp,
      resetField,
      login,
      isLogin,
      setCountDown,
      count,
      type,
      userSession,
    ]
  );

  useEffect(() => {
    setCountDown(count);
  }, [count]);
  useEffectAfterMount(() => {
    if (!!error) {
      setCountDown(0);
    } else {
      setCountDown(count);
    }
  }, [error]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (countDown > 0) {
        setCountDown((prevState) => prevState - 1);
      }
    }, 1000 * 1);
    return () => {
      clearTimeout(timeout);
    };
  }, [countDown]);

  return (
    <Stack
      direction={"row"}
      spacing={0}
      sx={{ alignItems: "center", color: "#000" }}
    >
      {countDown > 0 ? (
        <Typography>{t("resendIn")} {countDown} sec</Typography>
      ) : (
        <Button
          onClick={resendOtp}
          startIcon={<RefreshIcon />}
        >
          {t("resend")}
        </Button>
      )}
    </Stack>
  );
};

export default ResendOtp;
